/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EpaOperatorNotificationStatusEnum } from './EpaOperatorNotificationStatusEnum';
import {
    EpaOperatorNotificationStatusEnumFromJSON,
    EpaOperatorNotificationStatusEnumFromJSONTyped,
    EpaOperatorNotificationStatusEnumToJSON,
    EpaOperatorNotificationStatusEnumToJSONTyped,
} from './EpaOperatorNotificationStatusEnum';
import type { EpaNotificationRequest } from './EpaNotificationRequest';
import {
    EpaNotificationRequestFromJSON,
    EpaNotificationRequestFromJSONTyped,
    EpaNotificationRequestToJSON,
    EpaNotificationRequestToJSONTyped,
} from './EpaNotificationRequest';
import type { SimpleDataPointRequest } from './SimpleDataPointRequest';
import {
    SimpleDataPointRequestFromJSON,
    SimpleDataPointRequestFromJSONTyped,
    SimpleDataPointRequestToJSON,
    SimpleDataPointRequestToJSONTyped,
} from './SimpleDataPointRequest';
import type { SiteRequest } from './SiteRequest';
import {
    SiteRequestFromJSON,
    SiteRequestFromJSONTyped,
    SiteRequestToJSON,
    SiteRequestToJSONTyped,
} from './SiteRequest';

/**
 * Serializer for the EpaOperatorNotification model.
 * @export
 * @interface EpaOperatorNotificationRequest
 */
export interface EpaOperatorNotificationRequest {
    /**
     * 
     * @type {EpaNotificationRequest}
     * @memberof EpaOperatorNotificationRequest
     */
    notification: EpaNotificationRequest;
    /**
     * 
     * @type {SiteRequest}
     * @memberof EpaOperatorNotificationRequest
     */
    nearestSite: SiteRequest | null;
    /**
     * 
     * @type {Array<SiteRequest>}
     * @memberof EpaOperatorNotificationRequest
     */
    otherNearSites: Array<SiteRequest> | null;
    /**
     * 
     * @type {SimpleDataPointRequest}
     * @memberof EpaOperatorNotificationRequest
     */
    dataPoint: SimpleDataPointRequest | null;
    /**
     * 
     * @type {string}
     * @memberof EpaOperatorNotificationRequest
     */
    epaEmissionRecord?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EpaOperatorNotificationRequest
     */
    assignee?: number | null;
    /**
     * 
     * @type {EpaOperatorNotificationStatusEnum}
     * @memberof EpaOperatorNotificationRequest
     */
    status?: EpaOperatorNotificationStatusEnum;
}



/**
 * Check if a given object implements the EpaOperatorNotificationRequest interface.
 */
export function instanceOfEpaOperatorNotificationRequest(value: object): value is EpaOperatorNotificationRequest {
    if (!('notification' in value) || value['notification'] === undefined) return false;
    if ((!('nearestSite' in (value as Record<string, any>)) && !('nearest_site' in (value as Record<string, any>))) || ((value as Record<string, any>)['nearestSite'] === undefined && (value as Record<string, any>)['nearest_site'] === undefined)) return false;
    if ((!('otherNearSites' in (value as Record<string, any>)) && !('other_near_sites' in (value as Record<string, any>))) || ((value as Record<string, any>)['otherNearSites'] === undefined && (value as Record<string, any>)['other_near_sites'] === undefined)) return false;
    if ((!('dataPoint' in (value as Record<string, any>)) && !('data_point' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataPoint'] === undefined && (value as Record<string, any>)['data_point'] === undefined)) return false;
    return true;
}

export function EpaOperatorNotificationRequestFromJSON(json: any): EpaOperatorNotificationRequest {
    return EpaOperatorNotificationRequestFromJSONTyped(json, false);
}

export function EpaOperatorNotificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpaOperatorNotificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'notification': EpaNotificationRequestFromJSON(json['notification']),
        'nearestSite': SiteRequestFromJSON(json['nearest_site']),
        'otherNearSites': (json['other_near_sites'] == null ? null : (json['other_near_sites'] as Array<any>).map(SiteRequestFromJSON)),
        'dataPoint': SimpleDataPointRequestFromJSON(json['data_point']),
        'epaEmissionRecord': json['epa_emission_record'] === undefined ? undefined : json['epa_emission_record'] === null ? null : json['epa_emission_record'],
        'assignee': json['assignee'] === undefined ? undefined : json['assignee'] === null ? null : json['assignee'],
        'status': json['status'] == null ? undefined : EpaOperatorNotificationStatusEnumFromJSON(json['status']),
    };
}

export function EpaOperatorNotificationRequestToJSON(json: any): EpaOperatorNotificationRequest {
    return EpaOperatorNotificationRequestToJSONTyped(json, false);
}

export function EpaOperatorNotificationRequestToJSONTyped(value?: EpaOperatorNotificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notification': EpaNotificationRequestToJSON(value['notification']),
        'nearest_site': SiteRequestToJSON(value['nearestSite']),
        'other_near_sites': (value['otherNearSites'] == null ? null : (value['otherNearSites'] as Array<any>).map(SiteRequestToJSON)),
        'data_point': SimpleDataPointRequestToJSON(value['dataPoint']),
        'epa_emission_record': value['epaEmissionRecord'],
        'assignee': value['assignee'],
        'status': EpaOperatorNotificationStatusEnumToJSON(value['status']),
    };
}

